/*
 * @Description:
 * @Date: 2022-04-08 11:56:00
 * @LastEditTime: 2022-04-15 00:45:11
 */
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import './assets/css/style.css'
import './assets/icomoon/style.css'
import ElementPlus from 'element-plus'
import ja from 'element-plus/es/locale/lang/ja'
import { msalPlugin } from './plugins/msalPlugin'
import { msalInstance } from './utils/auth/authConfig'
import { AuthenticationResult, EventType } from '@azure/msal-browser'
import 'element-plus/dist/index.css'

// Account selection logic is app dependent. Adjust as needed for different use cases.
const accounts = msalInstance.getAllAccounts()

if (accounts.length > 0) {
  msalInstance.setActiveAccount(accounts[0])
}

msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult
    const account = payload.account
    msalInstance.setActiveAccount(account)
  }
})

createApp(App)
  .use(store as any)
  .use(router as any)
  .use(antd)
  .use(msalPlugin as any, msalInstance)
  .use(ElementPlus, { locale: ja })
  .mount('#app')
